module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(!_vm.single) ? _c('div', {
    staticClass: "is-relative"
  }, [_c('h3', {
    staticClass: "stepper__content__header"
  }, [_vm._v(_vm._s(_vm.$t('RISK_FACTORS')))])]) : _vm._e(), _vm._v(" "), (!_vm.single) ? _c('steps', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "activeStep": 10,
      "steps": 10
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content__wrapper flex-center"
  }, [_c('h4', {
    staticClass: "stepper__content__title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('DO_YOU_HAVE_CONFIRMED_BREAST_CHANGES')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('RIGHT_BREAST_COLON')))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8Val),
      expression: "s3q8Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "YES",
      "name": "right-breast"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q8Val, "YES")
    },
    on: {
      "click": function($event) {
        return _vm.showRightBreastSectionM(true)
      },
      "change": function($event) {
        _vm.s3q8Val = "YES"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('YES')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8Val),
      expression: "s3q8Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "NO",
      "name": "right-breast"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q8Val, "NO")
    },
    on: {
      "click": function($event) {
        return _vm.showRightBreastSectionM(false)
      },
      "change": function($event) {
        _vm.s3q8Val = "NO"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('NO')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), (_vm.showRightBreastSection) ? _c('right-breast-changes', {
    staticClass: "mt-3",
    on: {
      "clicked": function($event) {
        return _vm.rightClicked()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('LEFT_BREAST_COLON')))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q9Val),
      expression: "s3q9Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "YES",
      "name": "left-breast"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q9Val, "YES")
    },
    on: {
      "click": function($event) {
        return _vm.showLeftBreastSectionM(true)
      },
      "change": function($event) {
        _vm.s3q9Val = "YES"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('YES')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q9Val),
      expression: "s3q9Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "NO",
      "name": "left-breast"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q9Val, "NO")
    },
    on: {
      "click": function($event) {
        return _vm.showLeftBreastSectionM(false)
      },
      "change": function($event) {
        _vm.s3q9Val = "NO"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('NO')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), (_vm.showLeftBreastSection) ? _c('left-breast-changes', {
    staticClass: "mt-3",
    on: {
      "clicked": function($event) {
        return _vm.leftClicked()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.single) ? _c('div', [_c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-default mt-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('CANCEL')) + "\n                ")]), _vm._v(" "), (_vm.validateQ()) ? _c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-primary mt-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('SAVE')) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.validateQ()) ? _c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small mt-3",
    staticStyle: {
      "opacity": "0.5"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('SAVE')) + "\n                ")]) : _vm._e()]) : _c('div', [_c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-default mt-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goTo(9)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('PREVIOUS')) + "\n                ")]), _vm._v(" "), (_vm.validateQ()) ? _c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-primary mt-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.completeSection(4)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('NEXT')) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.validateQ()) ? _c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small mt-3",
    staticStyle: {
      "opacity": "0.5"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('NEXT')) + "\n                ")]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd2f8c94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/survey-step3-q8.vue
// module id = 1237
// module chunks = 0